// extracted by css-extract-rspack-plugin
var _1 = "BhUYOOhvWKcqpwnD";
var _2 = "SUIOLXWJt0Q6Xb6f";
var _3 = "TBmUy7Guuc1AETWK";
var _4 = "TBmUy7Guuc1AETWK";
var _5 = "IpD35hzQCrWhXqhi";
var _6 = "akQRrvmqAtSNkpHK";
var _7 = "BklZzInSRLkMVtNw";
var _8 = "Qk1emLBlVxoZ90ds";
var _9 = "akQRrvmqAtSNkpHK";
var _a = "BklZzInSRLkMVtNw";
var _b = "Qk1emLBlVxoZ90ds";
var _c = "BNmNmR1awMSQZjqE";
var _d = "j3edsb6h98KWE7aj";
var _e = "s4LPkDYyUpMBEd1U";
var _f = "j3edsb6h98KWE7aj";
var _10 = "s4LPkDYyUpMBEd1U";
export { _1 as "extracted", _2 as "extracting", _3 as "follow-btn", _4 as "followBtn", _5 as "identifier", _6 as "mode--final", _7 as "mode--group", _8 as "mode--knock_out", _9 as "modeFinal", _a as "modeGroup", _b as "modeKnockOut", _c as "team", _d as "team--pot", _e as "team--result", _f as "teamPot", _10 as "teamResult" }
